import { initializeApp } from "firebase/app";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";
import axios from "axios";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

initializeApp(firebaseConfig);
const db = getFirestore();

export const authenticateAnonymously = () => {
  const auth = getAuth();
  return signInAnonymously(auth);
};

export const getPrices = () => {
  const pricesDocRef = doc(db, "prices", "USD");
  return getDoc(pricesDocRef);
};

export const checkUser = async (email) => {
  const userType = await axios.put("https://api.codingx.app/users/ratings", {
    email,
  });
  return userType.data.data.proUser;
};

export const makeUserPro = async (email, paymentDetails) => {
  const headers = {
    "Content-Type": "application/json",
    app: "CodingX",
  };
  await axios.post(
    "https://admin.codingx.app/users",
    {
      email,
      paymentDetails,
    },
    { headers }
  );
};
